import { IListObjectStore } from "../../_common/type";
import { IJobHOCState } from "../../_core/job/types";
import { EMARPOLDocuments, TMARPOLProcessedTank } from "../marpol/@types";
import { TCRBA } from "./groups/crb-a";
import { TCRBB } from "./groups/crb-b";
import { TCRBC } from "./groups/crb-c";
import { TCRBD } from "./groups/crb-d";
import { TCRBE } from "./groups/crb-e";
import { TCRBF } from "./groups/crb-f";
import { TCRBG } from "./groups/crb-g";
import { TCRBH } from "./groups/crb-h";
import { TCRBI } from "./groups/crb-i";
import { TCRBJ } from "./groups/crb-j";
import { TCRBK } from "./groups/crb-k";

export enum ECRBOperationState {
	RECORD = "RECORD",
	PREVIEW = "PREVIEW",
}

export enum ESubstanceCategories {
	X = "Category X",
	Y = "Category Y",
	Z = "Category Z",
	OS = "Category OS",
}

export enum ECRBRecordState {
	APPROVED = "APPROVED",
	STRIKED_OFF = "STRIKED-OFF",
	SUBMITTED = "SUBMITTED",
	IDLE = "IDLE",
	EDIT = "EDIT",
	VERIFIED = "VERIFIED",
}

export type TCRBPlace =
	| {
			place: "IN_PORT";
			portName: string;
	  }
	| {
			place: "AT_SEA";
			startPosition: { latitude: string; longitude: string };
			endPosition: { latitude: string; longitude: string };
	  }
	| {
			place: "AT_RECEPTION_FACILITY";
			receiptNumber: string;
			receiptAttachment: string;
			//   originOfBallast: string;
			portName: string;
			receptionFacilityName: string;
	  };

export type TCRBRecordUser = {
	name: string;
	designation: string;
	staffId: string;
	date: string;
};

export type TCRBCommonFields = {
	selectedDate: string;
	remarks: string;
};

export type TCRBCommonData = {
	id: string;
	/**
	 * @description It's an ID for latest update for a document with given id.
	 */
	_rev: string;
	timeZone?: string;
	marpolType: EMARPOLDocuments.CRB;
	state: ECRBRecordState;
	submittedBy?: TCRBRecordUser;
	approvedBy?: TCRBRecordUser;
	verifiedBy?: TCRBRecordUser;
	strikedBy?: TCRBRecordUser;
	strikeOffReason?: string;
	editVersions?: TCRBBackendRecord[];
	dateOfApprovedRecordEdit?: string;
	_attachments?: object;
};

export type TCRBObservedQuantity = {
	preOperation: number;
	postOperation: number;
};

export enum ECRBRecordCode {
	CRBA = "CRB-A",
	CRBB = "CRB-B",
	CRBC = "CRB-C",
	CRBD = "CRB-D",
	CRBE = "CRB-E",
	CRBF = "CRB-F",
	CRBG = "CRB-G",
	CRBH = "CRB-H",
	CRBI = "CRB-I",
	CRBJ = "CRB-J",
	CRBK0 = "CRB-K0",
	CRBK1 = "CRB-K1", // Missed entry
	CRBK2 = "CRB-K2", // Additional operation (referred by PM Duke)
}

export type TCRBRecord =
	| TCRBA
	| TCRBB
	| TCRBC
	| TCRBD
	| TCRBE
	| TCRBF
	| TCRBG
	| TCRBH
	| TCRBI
	| TCRBJ
	| TCRBK;

export type TCRBCurrentOperationAlert = {
	id: string;
	type:
		| "WARNING"
		| "ERROR"
		| "INFO"
		| "REQUIRED_FIELD"
		| "OBSERVED_QUANTITY_ALERT";
	title: string;
	subtitle: string;
	message: string;
	listOfItems?: {
		title: string;
		subtitle?: string;
		message?: string;
		link?: string;
	}[];
	action?: {
		title: string;
		link: string;
	};
};

export type TCRBBackendRecord = TCRBRecord & {
	submittedBy: TCRBRecordUser;
	approvedBy?: TCRBRecordUser;
	verifiedBy?: TCRBRecordUser;
	strikedBy?: TCRBRecordUser;
	editedBy?: TCRBRecordUser;
	processedTanks: TCRBProcessedTank[];
	nonParticipantTanks: { id: string; expectedQuantity: number }[];
	isAutoCreated?: boolean;
	isEditWarningVisible?: boolean;
};

export enum ECRBEditMode {
	GENERAL = "GENERAL",
	APPROVED_EDIT = "APPROVED_EDIT",
}

export type TCRBProcessedTank = TMARPOLProcessedTank;

export type TCRBCurrentOperation = {
	recordCode: ECRBRecordCode;
	operationState: ECRBOperationState;
	formData: TCRBRecord;
	validationAlerts: IListObjectStore<TCRBCurrentOperationAlert>;
	processedTanks: IListObjectStore<TCRBProcessedTank>;
	editMode?: ECRBEditMode;
};

export type TCRBHistoryFilters = {
	startDate: any;
	endDate: any;
	shownRecords: "ALL" | "ALL-PENDING";
	state?: ECRBRecordState | string;
	sortOrder?: "asc" | "desc";
	vesselId: string;
};

export interface ICRBStore extends IJobHOCState {
	records: IListObjectStore<TCRBBackendRecord>;
	currentOperation?: TCRBCurrentOperation;
	filter: TCRBHistoryFilters;
}
